import { render, staticRenderFns } from "./ChatMessageBody.vue?vue&type=template&id=68c66ef2&"
import script from "./ChatMessageBody.vue?vue&type=script&lang=js&"
export * from "./ChatMessageBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports